import { Network } from "@/network";
import { TCBReceiptApi } from "@/network/pb/proto";
import { Log } from "@/util";

class DepositModel {
    private static sInstance: DepositModel;

    public static get instance(): DepositModel {
        if (!DepositModel.sInstance) {
            DepositModel.sInstance = new DepositModel();
        }

        return DepositModel.sInstance;
    }

    private storeUserPermissionMap = TCBReceiptApi.Protobuf.StoreUserPermissionMap.create();
    private reconciliationList = TCBReceiptApi.Protobuf.ReconciliationList.create();
    private depositCollectionMap = TCBReceiptApi.Protobuf.DepositCollectionMap.create();
    private depositCollection = TCBReceiptApi.Protobuf.DepositCollection.create();
    private depositTotal = TCBReceiptApi.Protobuf.DepositTotal.create();

    // 搜尋 - 特店清單
    public async getStoreSearch(storeInsertQuery: Uint8Array): Promise<void> {
        await Network.sendAPI(
            "/api/front/reimbursement/get_store_list_by_tid_number",
            "post",
            storeInsertQuery
        )
            .then((rawResponse) => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                this.storeUserPermissionMap = TCBReceiptApi.Protobuf.StoreUserPermissionMap.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch((error) => {
                Log.error(error);
            });
    }

    // 搜尋 - 特約商店存摺入帳交易查詢
    public async getReimbursement(depositQuery: Uint8Array): Promise<void> {
        await Network.sendAPI(
            "/api/front/deposit/get_store_list_by_condition",
            "post",
            depositQuery
        )
            .then((rawResponse) => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                this.reconciliationList = TCBReceiptApi.Protobuf.ReconciliationList.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch((error) => {
                Log.error(error);
            });
    }

    // 搜尋 - 展開前三筆資料之map
    public async getDepositCollectionMap(
        depositQuery: Uint8Array
    ): Promise<void> {
        await Network.sendAPI("/api/front/deposit/get_by_condition", "post", depositQuery)
            .then((rawResponse) => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                this.depositCollectionMap = TCBReceiptApi.Protobuf.DepositCollectionMap.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch((error) => {
                Log.error(error);
            });
    }

    // 搜尋 - 取得展開資料 (單一筆)
    public async getDepositCollection(depositQuery: Uint8Array): Promise<void> {
        await Network.sendAPI(
            "/api/front/deposit/get_specific_by_condition",
            "post",
            depositQuery
        )
            .then((rawResponse) => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                this.depositCollection = TCBReceiptApi.Protobuf.DepositCollection.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch((error) => {
                Log.error(error);
            });
    }

    // 統計
    public async getDepositTotal(
        depositQuery: Uint8Array
    ): Promise<void> {
        await Network.sendAPI(
            "/api/front/deposit/get_total_by_condition",
            "post",
            depositQuery
        )
            .then((rawResponse) => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                this.depositTotal = TCBReceiptApi.Protobuf.DepositTotal.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch((error) => {
                Log.error(error);
            });
    }

    /* ----列印頁面---- */
    public async getPrintDepositCollectionMap(
        depositQuery: Uint8Array
    ): Promise<TCBReceiptApi.Protobuf.DepositCollectionMap> {
        let map = TCBReceiptApi.Protobuf.DepositCollectionMap.create();

        await Network.sendAPI(
            "/api/front/deposit/get_print_by_condition",
            "post",
            depositQuery
        )
            .then((rawResponse) => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );

                map = TCBReceiptApi.Protobuf.DepositCollectionMap.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch((error) => {
                Log.error(error);
            });

        return map;
    }
    /* ----列印頁面---- */    

    // 取得特店清單列表
    public getStoreList(): TCBReceiptApi.Protobuf.StoreUserPermissionMap {
        return this.storeUserPermissionMap;
    }

    // 取得搜尋結果 - 列表
    public getReimbursementList(): TCBReceiptApi.Protobuf.ReconciliationList {
        return this.reconciliationList;
    }

    // 取得搜尋結果 - 展開資料map (前三筆)
    public getDepositCollectionMapData(): TCBReceiptApi.Protobuf.DepositCollectionMap {
        return this.depositCollectionMap;
    }

    // 取得搜尋結果 - 取得展開資料 (單一筆)
    public getDepositCollectionData(): TCBReceiptApi.Protobuf.DepositCollection {
        return this.depositCollection;
    }

    // 取得搜尋結果 - 統計
    public getDepositTotalData(): TCBReceiptApi.Protobuf.DepositTotal {
        return this.depositTotal;
    }

    // 取得請款匯出
    public async exportDeposit(queryString: string): Promise<void> {
        const uri = "/api/front/deposit/get_export_by_condition?" + queryString;
        await Network.downloadFile(uri);
    }
}

const reimbursementModel = DepositModel.instance;

export { reimbursementModel as DepositModel };
